export default __webpack_public_path__ + "static/media/money-receipt-template-1.15587c28.png";